// extracted by mini-css-extract-plugin
module.exports = {"switch":"_02712f2b3b--switch--Iu4Bo","indicator":"_02712f2b3b--indicator--JD6wH","disabled":"_02712f2b3b--disabled--WS_Zh"};